/** Email notification outcome for a verification history action. */
export enum EmailStatus {
    /** The action has no associated email. */
    NONE = 'NONE',
    /** An email was sent for this action. */
    SENT = 'SENT',
    /** An email would have been sent, but the acting user suppressed notifications. */
    SUPPRESSED = 'SUPPRESSED'
}
